import styled from '@emotion/styled';
import { mobileOnly } from '../../utils/sharedStyles';

export const desktopCategory = 'desktop-category';
export const menuItemClass = 'desktop-menu-item';

/*
  The 'display: none' at the 'nav' level is used to hide the component from voice over, but
  provides no added value visually since the same can be done with the display none within 
  desktopCategory.
 */
export const StyledNav = styled.nav`
  display: block;
  position: absolute;
  width: 100%;
  left: 0;
  right: 0;
  .${desktopCategory} {
    display: flex;
    justify-content: center;
    margin: 0 auto;

    /** 
     * hides content that would overlap the search icon
     * setting a width, setting a height, adding flex-wrap and hiding overflow
     * means any content that would overlap overflows underneath the menu 
     * the specific pixel values came from v2
    */
    height: 60px;
    flex-wrap: wrap;
    width: calc(100% - 616px);
    overflow: hidden;
    max-width: 1255px;
    @media only screen and (max-width: 1200px) {
      // minimized search bar width + padding on right * 2 since the shopping menu is centered
      width: calc(100% - 330px);
    }
    .${menuItemClass} {
      font: var(--podium-cds-typography-body1-strong);
      padding-right: 5px;
      padding-left: 5px;
      display: flex;
      padding-bottom: 0px;
    }
  }
  @media (${mobileOnly}) {
    display: none;
    .${desktopCategory} {
      display: none;
    }
  }
`;
